import React, {useState} from 'react';
import { classNames } from '../../Services/helpers';
import Icon from '../Icons/Icon';
import Loading from '../Loading';

const ButtonBar = ({buttons, className, size = "md", align = "justified"}) => {
    const alignmentClasses = {
        'left': 'justify-start',
        'right': 'justify-end',
    };

    const containerClasses = {
        'left': 'w-full',
        'right': 'w-auto',
        'justified': 'w-full',
    };

    return <div className={classNames(
        'flex flex-row align-middle gap-2 surface-2 p-1 rounded-lg shadow-inner',
        alignmentClasses[align] || 'justify-around',
        containerClasses[align] || containerClasses.justified,
        className
    )}>
        {buttons.map((button) => <Button key={button.label ?? button.icon} size={size} align={align} {...button} />)}
    </div>
}

const Button = ({label, icon, loading, onClick, onClickLoading, selected, size, align, disabled}) => {
    const [isLoading, setIsLoading] = useState(false);

    const handleClick = async (e) => {
        e.preventDefault();
        e.stopPropagation();

        try {
            onClickLoading && setIsLoading(true);

            onClick && await onClick();

            onClickLoading && setIsLoading(false);
        } catch (error) {
            onClickLoading && setIsLoading(false);
            throw error;
        }
    }

    const iconTheme = selected ? 'solid' : 'light';
    const _loading = loading || isLoading;
    const iconMargin = label ? 'mr-2' : '';

    const sizeClasses = {
        'xs': 'px-2 py-0.5 text-xs',
        'sm': 'px-3 py-1',
        'md': 'px-4 py-2',
    };

    const growClass = align === 'right' ? '' : 'grow';

    return <button className={classNames(
        sizeClasses[size] || sizeClasses.md,
        growClass,
        'rounded-lg transition-bg duration-300',
        selected && 'surface-1 font-bold shadow-xs',
        !disabled && 'dark:hover:bg-black/75 text-muted hover:bg-white/75 hover:cursor-pointer',
        selected && 'text-brand fill-brand',
        disabled && 'fill-muted cursor-not-allowed',
    )} onClick={handleClick} disabled={disabled}>
        {_loading && <Loading className={iconMargin} />}
        {(!_loading && icon) && <Icon icon={icon} theme={iconTheme} className={iconMargin} />}
        {label}
    </button>
}

export default ButtonBar;
